import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// Use token directly from env
mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN;

function MapboxMap({ listings = [] }) {
  const mapContainer = useRef(null);
  const map = useRef(null);

  // Simple map initialization
  useEffect(() => {
    
    if (!mapContainer.current) {
      console.error("No container ref!");
      return;
    }
    if (!mapboxgl.accessToken) {
      console.error("No Mapbox token!");
      return;
    }
    
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-121.3153, 44.0582],
      zoom: 10
    });
    
    return () => map.current?.remove();
  }, [listings]);

  return (
    <div style={{ 
      width: '100%', 
      height: '400px',
      position: 'relative',
      background: '#eee'
    }}>
      <div 
        ref={mapContainer}
        style={{ 
          position: 'absolute', 
          top: 0, 
          bottom: 0, 
          left: 0, 
          right: 0,
          background: '#f0f0f0'
        }}
      />
    </div>
  );
}

export default MapboxMap;
